var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0"},[_c('v-row',[_c('v-col',{attrs:{"cols":"8"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.page.data)}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }